import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CompanyManager } from 'src/app/core/managers/company.manager';
// import { Cargo } from 'src/app/core/models/cargo.model';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { ManualCreationCargoService } from '../manual-creation-cargo/manual-creation-cargo.service';
import { CargoResources } from '../manual-creation-cargo/resources/cargo';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ItemAdditionalService } from './item-additional-service.service';
import { Dialog } from 'src/app/core/resources/dialog';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { AdditionalCostUpdate } from 'src/app/core/interfaces/additionalCostCargo';
import { BasicResponse } from 'src/app/core/interfaces/basicResponse';
import { NgxSpinnerService } from 'ngx-spinner';
import { RateCostAdditionalServicesComponent } from '../rate-cost-additional-services/rate-cost-additional-services.component';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';
import { ShippingCost } from 'src/app/core/enums/shipping-cost.enum';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Utils } from 'src/app/core/resources/utils';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/authentication.service';
import { AdditionalCost } from 'src/app/core/interfaces/additionalCost';
import { CargoShippingCostDialogComponent } from '../cargo-shipping-cost-dialog/cargo-shipping-cost-dialog.component';
import { Company } from 'src/app/core/interfaces/company';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
@Component({
  selector: 'app-item-additional-service',
  templateUrl: './item-additional-service.component.html',
  styleUrls: ['./item-additional-service.component.scss']
})
export class ItemAdditionalServiceComponent implements OnInit, OnChanges {
  @Input() cargo: Cargo;
  @Input() cargoId: string;
  @Input() additionalServiceGroupCtrl: FormGroup;
  @Input() index: number;
  @Input() companyId: string;
  @Input() approvalState: string;
  @Input() cargoApproval: string;
  @Input() public listAdditionalService: AdditionalCost[] = [];
  @Input() consignments: string[] = [];
  @Output() removeAdditionalCostItem: EventEmitter<number> = new EventEmitter();
  @Output() editAdditionalCostItem: EventEmitter<number> = new EventEmitter();
  public validUtility: boolean;
  utilityAditionalServicesCargoResul: number;
  activeSave: boolean = false;
  observationFieldState: any;
  activeEdit: boolean = false;
  permission = Permission;
  isCollapsedhistoryAdditionalServices: boolean = false;
  isCollapsedFingerPrint: boolean = false;
  showArrowDown: boolean = true;
  checkUtility: boolean = true;
  utilityRequired: number = 0;
  companyUser: Company;
  companyName: string;
  previousFormValues: { [key: string]: string } = {};
  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    public cargoResources: CargoResources,
    public cargoItemService: CargoItemService,
    public managerComany: CompanyManager,
    public dialog: MatDialog,
    public itemAdditionalService: ItemAdditionalService,
    public matDialog: Dialog,
    public snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private permissionRole: PermissionRole,
    public cargoDetailService: CargoDetailService,
    public utils: Utils,
    private authService: AuthService
  ) {
  }

  async ngOnInit() {
    this.ensureObservationControl();
    await this.getUtilityByCompany();
    this.additionalServiceGroupCtrl.setValidators(this.utilityValidator.bind(this));
    if (this.isRateLockedByBilling) {
      const rateCtrl = this.additionalServiceGroupCtrl.get('financialInformation.rate');
      if (rateCtrl) rateCtrl.disable({ emitEvent: false });
    }
    this.additionalServiceGroupCtrl.updateValueAndValidity();
    this.companyUser = this.authService && this.authService.getCompany();
    this.companyName = this.companyUser.name;
  }

  // El catálogo de servicios (con la utilidad por servicio/actor) llega por HTTP después de pintar los items;
  // sin recalcular, la utilidad requerida se queda con el respaldo de la empresa.
  async ngOnChanges(changes: SimpleChanges) {
    if (!changes.listAdditionalService || changes.listAdditionalService.firstChange || !this.additionalServiceGroupCtrl) return;
    await this.getUtilityByCompany();
    this.additionalServiceGroupCtrl.updateValueAndValidity();
  }

  private ensureObservationControl() {
    if (!this.additionalServiceGroupCtrl.get('observation')) {
      this.additionalServiceGroupCtrl.addControl('observation', new FormControl({
        value: '',
        disabled: this.additionalServiceGroupCtrl.disabled
      }));
    }
  }

  private utilityValidator(form): { [key: string]: any } {
    if (!this.checkUtility)
      return null;

    const rateControl = form.get('financialInformation.rate');
    const rateRaw = rateControl && rateControl.value;
    const rateNumber = this.isRateLockedByBilling
      ? 0
      : parseInt((rateRaw || 0).toString().replace(/[.]/g, ''));
    const costControl = form.get('financialInformation.cost');
    const costRaw = costControl && costControl.value;
    const costNumber = parseInt((costRaw || 0).toString().replace(/[.]/g, ''));

    let utility: number = this.cargoItemService.getExactUtilityCargo(rateNumber, costNumber);
    if (utility < this.utilityRequired) return { 'utility': true };
    else return null;
  }

  onKeyUp($event, key: string) {
    this.additionalServiceGroupCtrl.get(key).setValue(
      parseInt($event.target.value)
    );
  }

  async onChangeUploadDownloadFor($event) {
    const uploadDownloadFor = this.uploadDownloadForOptions.filter((obj) => {
      return obj.code === $event.value;
    });
    if (uploadDownloadFor.length) {
      this.additionalServiceGroupCtrl.get('toPay').patchValue({
        code: uploadDownloadFor[0].code,
        description: uploadDownloadFor[0].description
      });
    }
    await this.getUtilityByCompany();
    this.additionalServiceGroupCtrl.setValidators(this.utilityValidator.bind(this));
    this.additionalServiceGroupCtrl.updateValueAndValidity();
  }

  async onSelectBodyGuardType($event) {
    this.additionalServiceGroupCtrl.get('observation').setValue(
      $event.value
    );
  }

  editAdditionalService() {
    this.checkPreviousValues();
    if (!!this.additionalServiceGroupCtrl.get('financialInformation.paid').value)
      return this.snackBarService.openSnackBar('El servicio adicional ya fue pagado.', undefined, 'alert');
    const canModify = this.canModifyAdditionalService();
    if (!canModify.canModify) return this.snackBarService.openSnackBar(canModify.message, undefined, 'alert');
    this.activeSave = !this.activeSave;
    this.validateTypeAdditionalService();
  }


  checkPreviousValues() {
    if (this.additionalServiceGroupCtrl && this.additionalServiceGroupCtrl.get('consignment')) {
      this.previousFormValues['consignment'] = this.additionalServiceGroupCtrl.get('consignment').value ? this.utils.clone(this.additionalServiceGroupCtrl.get('consignment').value) : this.additionalServiceGroupCtrl.get('consignment').value;
    }
    if (this.additionalServiceGroupCtrl && this.additionalServiceGroupCtrl.get('observation')) {
      this.previousFormValues['observation'] = this.additionalServiceGroupCtrl.get('observation').value ? this.utils.clone(this.additionalServiceGroupCtrl.get('observation').value) : this.additionalServiceGroupCtrl.get('observation').value;
    }
    if (this.additionalServiceGroupCtrl && this.additionalServiceGroupCtrl.get('toPay') && this.additionalServiceGroupCtrl.get('toPay').value
      && this.additionalServiceGroupCtrl.get('toPay').value.code && this.additionalServiceGroupCtrl.get('toPay').value.description) {
      this.previousFormValues['toPay'] = this.additionalServiceGroupCtrl.get('toPay').value ? this.utils.clone(this.additionalServiceGroupCtrl.get('toPay').value) : this.additionalServiceGroupCtrl.get('toPay').value;
    }
  }

  deleteAdditionalService() {
    if (!!this.additionalServiceGroupCtrl.get('financialInformation.paid').value)
      return this.snackBarService.openSnackBar(`No es posible eliminar el servicio adicional. El servicio ya fue pagado.`, undefined, 'alert')
    if (this.utils.getNestedValue(this.cargo, 'shippingCost.cashed'))
      return this.snackBarService.openSnackBar(`No es posible eliminar el servicio adicional. El servicio ya está facturado.`, undefined, 'alert')
    if (this.utils.getNestedValue(this.cargo, 'prevalidation.valid') && !this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.deleteAdditionalServicesBilled))
      return this.snackBarService.openSnackBar(`No cuentas con el permiso necesario. El servicio está validado para facturar`, undefined, 'alert');
    if (!this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.deleteAdditionalServicesApproved) && this.approvalState === 'Approved')
      return this.snackBarService.openSnackBar(`No cuentas con el permiso necesario. El servicio está aprobado`, undefined, 'alert')
    this.matDialog.openDialog({
      title: '¿Está seguro que desea eliminar el servicio adicional?',
      showYesBtn: true,
      showNoBtn: true,
      hideBtnCancel: true
    }).then(() => {

      if (this.additionalServiceGroupCtrl.value.id === undefined || this.additionalServiceGroupCtrl.value.id === null || this.additionalServiceGroupCtrl.value.id === "") {
        this.snackBarService.openSnackBar("No es posible borrar el servicio adicional por favor contactar al equipo de desarrollo", undefined, "alert");
      } else {
        this.spinner.show();
        this.itemAdditionalService.deleteAdditionalService(this.cargoId, this.additionalServiceGroupCtrl.value.id).subscribe(
          success => {
            this.spinner.hide();
            this.removeAdditionalCostItem.emit(this.index);
            this.manualCreationCargoService.showMessageSuccessDelete();
          },
          error => {
            this.spinner.hide();
            this.manualCreationCargoService.showMessageErrorDelete();
          }
        )
      }

    }).catch(err => err)

  }

  cancelEdit() {
    this.assignPreviousValues();
    this.validateTypeAdditionalService();
    this.activeSave = false;
  }

  assignPreviousValues() {
    if ('consignment' in this.previousFormValues) this.additionalServiceGroupCtrl.get('consignment').setValue(this.previousFormValues['consignment']);
    if ('observation' in this.previousFormValues) this.additionalServiceGroupCtrl.get('observation').setValue(this.previousFormValues['observation']);
    if ('toPay' in this.previousFormValues) this.additionalServiceGroupCtrl.get('toPay').patchValue(this.previousFormValues['toPay']);
  }

  saveEdit() {
    if (this.additionalServiceGroupCtrl.valid) {
      this.spinner.show();
      this.activeSave = false;
      this.validateTypeAdditionalService();
      let body = this.validateBodyToUpdate();
      this.updateAdditionalService(body);
    } else {
      this.snackBarService.openSnackBar(FormMessages.MINIMUN_UTILITY_NOT_REACHED_DEFAULT, undefined, 'alert');
    }
  }

  updateAdditionalService(body) {
    this.itemAdditionalService.editAdditionalService(body, this.cargoId)
      .subscribe((success: BasicResponse) => {
        this.spinner.hide();
        if (success.message === 'Actualizado') {
          this.manualCreationCargoService.showMessageSuccessEdit();
        } else if (success.message) {
          this.spinner.hide();
          this.snackBarService.openSnackBar(success.message, undefined, 'error');
        } else {
          this.spinner.hide();
          this.snackBarService.openSnackBar('Ocurrió un error al realizar la actualización, contacte al equipo de desarrollo', undefined, 'error');
        }
      },
        error => {
          this.snackBarService.openSnackBar('Ocurrió un error al enviar la información', undefined, 'error');
          this.spinner.hide();
        })
  }

  validateBodyToUpdate() {
    let body: AdditionalCostUpdate = {
      id: this.additionalServiceGroupCtrl.value.id,
      toPay: {
        code: "",
        description: ""
      },
      observation: "",
      financialInformation: {
        rate: this.additionalServiceGroupCtrl.get('financialInformation.rate').value,
        cost: this.additionalServiceGroupCtrl.get('financialInformation.cost').value
      }
    };
    if (this.additionalServiceGroupCtrl.get('consignment') && this.additionalServiceGroupCtrl.get('consignment').value)
      body['consignment'] = this.additionalServiceGroupCtrl.get('consignment').value;
    if (this.additionalServiceGroupCtrl.get('observation')) {
      body.observation = this.additionalServiceGroupCtrl.get('observation').value;
    } else {
      delete body.observation;
    }
    if (!(this.additionalServiceGroupCtrl.get('toPay.description')) || !(this.additionalServiceGroupCtrl.get('toPay.code'))) {
      delete body.toPay;
    } else {
      body.toPay.code = this.additionalServiceGroupCtrl.get('toPay.code').value;
      body.toPay.description = this.additionalServiceGroupCtrl.get('toPay.description').value;
    }
    return body;
  }

  validateTypeAdditionalService() {
    if (this.serviceName && this.listAdditionalService.map(additionalService => additionalService.name).includes(this.serviceName)) {
      if (this.additionalServiceGroupCtrl.disabled) {
        this.activeEdit = true;
        this.additionalServiceGroupCtrl.enable();
        this.additionalServiceGroupCtrl.get('financialInformation.cost').disable();
        this.additionalServiceGroupCtrl.get('financialInformation.rate').disable();
        this.additionalServiceGroupCtrl.get('financialInformation').disable();
      } else {
        this.activeEdit = false;
        this.additionalServiceGroupCtrl.disable({ emitEvent: false });
      }
    }
  }

  private canModifyAdditionalService(): { canModify: boolean, message?: string } {
    const isAdditionalServicePaid = !!this.additionalServiceGroupCtrl.get('financialInformation.paid').value;
    const isPaid = this.utils.getNestedValue(this.cargo, 'shippingCost.paid');
    const permissionPaid = this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.modifyAdditionalCostpayed);
    const isValidated = !!this.utils.getNestedValue(this.cargo, 'prevalidation.valid');
    const isCashed = !!(this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.cashed);
    const permissionValidated = this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.modifyAdditionalCostBilled);
    if (isCashed && isAdditionalServicePaid)
      return { canModify: false, message: 'El servicio adicional ya fue facturado y pagado.' };
    if (isAdditionalServicePaid && !permissionPaid)
      return { canModify: false, message: 'No tienes permisos para modificar un servicio adicional que ya fue pagado.' };
    if (isPaid && !permissionPaid)
      return { canModify: false, message: 'No tienes permisos para modificar un servicio que ya fue pagado.' };
    if (isValidated && !permissionValidated)
      return { canModify: false, message: 'No tienes permisos para modificar un servicio validado para facturar.' };
    if (isCashed && !permissionValidated)
      return { canModify: false, message: 'No tienes permisos para modificar un servicio facturado.' };
    return { canModify: true };
  }

  private canModify(type: 'amount' | 'amountRate'): { canModify: boolean, message: string } {
    if (!this.cargo || !this.cargo.approval || !this.cargo.shippingCost)
      return { canModify: false, message: 'No está permitido realizar modificaciones a este servicio' };
    const isCashed = this.utils.getNestedValue(this.cargo, 'shippingCost.cashed');
    const isAdditionalServicePaid = !!this.utils.getNestedValue(this.rawValueForm, 'financialInformation.paid');
    if (type === 'amount' && isAdditionalServicePaid)
      return { canModify: false, message: 'No se puede modificar el costo porque el servicio adicional ya fue pagado.' };
    if (type === 'amountRate' && isCashed)
      return { canModify: false, message: 'No se puede modificar la tarifa porque el servicio ya fue facturado. Reversa la factura para modificar.' };
    return { canModify: true, message: '' };
  }

  rateCostAdditionalService() {
    const canModify = this.canModifyAdditionalService();
    if (!canModify.canModify) return this.snackBarService.openSnackBar(canModify.message, undefined, 'alert');
    const canModifyRate = this.canModify('amountRate');
    const canModifyAmount = this.canModify('amount');
    if (!canModifyAmount.canModify && !canModifyRate.canModify)
      return this.snackBarService.openSnackBar("No es posible realizar modificaciones a este servicio adicional", undefined, 'alert');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      finantialInfo: this.additionalServiceGroupCtrl,
      person: this.personCost,
      companyId: this.companyId,
      utilityRequired: this.utilityRequired,
      toPayDescription: this.toPayDescription,
      cargo: this.cargo,
      adittionalServiceId: this.additionalServiceGroupCtrl.value.id,
      canModifyRate: canModifyRate,
      canModifyAmount: canModifyAmount,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(RateCostAdditionalServicesComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        this.editAdditionalCostItem.emit(result.state)
      }
    })
  }


  openHistoryDiscountsAndBonusesAdditionalServices(type) {
    const history = this.cargoDetailService.getHistoryDiscountsAndBonusesAdditionalServices(this.additionalServiceGroupCtrl.value, type);

    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      shippingCostToDisplay: history,
      typePayment: 'DiscountsAndBonuses'
    };
    this.dialog
      .open(CargoShippingCostDialogComponent, config)
      .afterClosed()
      .subscribe(
        () => { }
      );
  }

  toggleCollapsehistoryAdditionalServices() {
    this.isCollapsedhistoryAdditionalServices = !this.isCollapsedhistoryAdditionalServices;
    this.showArrowDown = !this.showArrowDown
  }
  showFingerPrintInfo() {
    this.isCollapsedFingerPrint = !this.isCollapsedFingerPrint;
  }

  cleanConsignment() {
    this.additionalServiceGroupCtrl.get('consignment').setValue('');
    this.checkPreviousValues();
  }

  get rawValueForm() {
    return this.additionalServiceGroupCtrl.getRawValue();
  }

  get serviceName(): string {
    const rawValue = this.rawValueForm;
    return rawValue && rawValue.type && rawValue.type.name ? rawValue.type.name : '';
  }

  get showObservationField(): boolean {
    return this.serviceName !== 'Servicios de escolta';
  }

  get showtoggleCollapsehistoryOption() {
    const haveTotalBonusesOrDiscounts = this.cargoItemService.getTotalDiscountsRateAdditionalServices(this.additionalServiceGroupCtrl.value) || this.cargoItemService.getTotalDiscountsCostAdditionalServices(this.additionalServiceGroupCtrl.value) || this.cargoItemService.getTotalBonusesRateAdditionalServices(this.additionalServiceGroupCtrl.value) || this.cargoItemService.getTotalBonusesCostAdditionalServices(this.additionalServiceGroupCtrl.value);

    if (haveTotalBonusesOrDiscounts) {
      if (this.showAdditionalCost && (this.cargoItemService.getTotalDiscountsCostAdditionalServices(this.additionalServiceGroupCtrl.value) || this.cargoItemService.getTotalBonusesCostAdditionalServices(this.additionalServiceGroupCtrl.value))) {
        return true;
      } else if (this.showAdditionalRate && (this.cargoItemService.getTotalDiscountsRateAdditionalServices(this.additionalServiceGroupCtrl.value) || this.cargoItemService.getTotalBonusesRateAdditionalServices(this.additionalServiceGroupCtrl.value))) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get showBtnDeleteAdditionalService() {
    return this.permissionRole.hasPermission(this.permission.cargo.module,
      this.permission.cargo.additionalCostDelete
    );
  }

  get showBtnEditAdditionalService() {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalCostUpdate);
  }

  get showAdditionalCost() {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showCostCargo) || this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalCostUpdate) || this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalCostCreate)
  }

  get showAdditionalRate() {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showRateCargo) || this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalCostUpdate) || this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalCostCreate)
  }

  get personCost(): string {
    let person = '';
    switch (this.serviceName) {
      case 'Stand by':
      case 'Servicio descargue':
      case 'Servicio cargue':
        if (this.additionalServiceGroupCtrl.get('toPay') && this.additionalServiceGroupCtrl.get('toPay.description'))
          person = this.additionalServiceGroupCtrl.get('toPay.description').value;
        break;
      case 'Servicios de escolta':
      case 'Sello satelital':
      case 'Servicio de almacenamiento':
      case 'Servicio ITR':
      case 'OTM':
        person = 'PROVEEDOR';
        break;
    }
    return person;
  }

  get isRateLockedByBilling(): boolean {
    return !!this.utils.getNestedValue(this.cargo, 'prevalidation.valid')
      || !!this.utils.getNestedValue(this.cargo, 'shippingCost.cashed');
  }

  get uploadDownloadForOptions(): { code; description }[] {
    const list = (this.cargoResources.listUploadDownloadFor || []).slice();
    const hideDriver = !this.additionalServiceGroupCtrl.disabled
      && (this.cargoApproval === 'Approved' || this.cargoApproval === 'Rejected');
    if (!hideDriver) return list;
    return list.filter(option => option.code != 'C');
  }

  async getUtilityByCompany() {

    //Utilidad por servicio adicional por whoToPay
    let utilityByWhoToPay: number;
    if (!this.serviceName) return;
    const service: AdditionalCost = this.listAdditionalService.find(service => service && service.name && service.name.toLocaleUpperCase() === this.serviceName.toLocaleUpperCase());
    if (service) {
      switch (this.serviceName) {
        case 'Stand by':
        case 'Servicio descargue':
        case 'Servicio cargue':
          if (service.utilityByActor !== false && this.additionalServiceGroupCtrl.get('toPay') && this.additionalServiceGroupCtrl.get('toPay.code') && service.whoToPaysUtilities && service.whoToPaysUtilities.length) {
            const whoToPay = service.whoToPaysUtilities.find(who => who.whoToPayId === this.additionalServiceGroupCtrl.get('toPay.code').value);
            if (whoToPay && this.utils.isDefined(whoToPay.utility)) utilityByWhoToPay = whoToPay.utility;
          }
          // Configurado con utilidad general (no por actor) o sin dato para ese actor: aplica la del servicio.
          if (!this.utils.isDefined(utilityByWhoToPay) && this.utils.isDefined(service.utility)) utilityByWhoToPay = service.utility;
          break;
        default:
          if (this.utils.isDefined(service.utility)) utilityByWhoToPay = service.utility;
          break;
      }
    }

    //Utilidad por compañía propietaria
    const utilityResult = await this.managerComany.getutilityAdditionalServicesByCompanyId(this.companyId);
    const utilityOwner = this.manualCreationCargoService.getutilityAdditionalServiceOwner();
    const utilityByCompany = utilityOwner ? utilityOwner : utilityResult;

    //Utilidad por defecto
    const defaultMinUtility = this.authService && this.authService.getCompany() && this.authService.getCompany().companyId && this.authService.getCompany().companyId === environment.rootNit
      ? this.ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST_TECLOGI
      : this.ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST;


    this.utilityRequired = this.utils.isDefined(utilityByWhoToPay)
      ? utilityByWhoToPay
      : this.utils.isDefined(utilityByCompany)
        ? utilityByCompany
        : defaultMinUtility;
    if (this.additionalServicesWithoutUtilityRestriction)
      this.checkUtility = false;
    else
      this.checkUtility = !!this.utilityRequired;
  }

  get ShippingCost() {
    return ShippingCost;
  }

  get currentUtility(): number {
    let rate: number = this.additionalServiceGroupCtrl.get('financialInformation.rate').value | 0;
    let cost: number = this.additionalServiceGroupCtrl.get('financialInformation.cost').value | 0;
    if (rate === 0) return 0;
    return (rate - cost) / rate * 100;
  }

  // En edición tarifa/costo quedan deshabilitados; al cambiar "Cuenta para pagar a" la utilidad requerida
  // puede subir, así que se muestra la alerta solo cuando deja de cumplirse.
  get showUtilityAlertOnEdit(): boolean {
    return this.activeSave && ((this.checkUtility && this.currentUtility < this.utilityRequired) || this.warnUtilityBelowRequired);
  }

  // Con permiso sin restricción no se bloquea, pero se avisa que queda por debajo de la utilidad requerida.
  get warnUtilityBelowRequired(): boolean {
    return this.additionalServicesWithoutUtilityRestriction && !!this.utilityRequired && this.currentUtility < this.utilityRequired;
  }

  get toPayDescription(): string {
    if (!['Servicio cargue', 'Servicio descargue', 'Stand by'].includes(this.serviceName)) return '';
    const descriptionCtrl = this.additionalServiceGroupCtrl && this.additionalServiceGroupCtrl.get('toPay.description');
    return descriptionCtrl && descriptionCtrl.value ? descriptionCtrl.value : '';
  }

  get utilityAlertClass(): string {
    if (this.warnUtilityBelowRequired) return 'alert-warning';
    if (this.checkUtility) {
      if (this.currentUtility === this.utilityRequired) return 'alert-primary';
      if (this.currentUtility > this.utilityRequired) return 'alert-success';
      if (this.currentUtility < this.utilityRequired) return 'alert-danger';
    }
    return 'alert-primary';
  }

  get additionalServicesWithoutUtilityRestriction(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.additionalServicesWithoutUtilityRestriction);
  }

}
